import { type MetaFunction } from '@remix-run/node'

import { Footer, Header } from '#app/components'
import { Wrapper } from '#app/components/ui'
import { useOptionalUser } from '#app/utils/user.ts'

export default function PrivacyRoute() {
	const user = useOptionalUser()
	const isLoggedIn = user?.id ? true : false
	return (
		<main>
			<Header isLoggedIn={isLoggedIn} />
			<div className="flex w-full flex-col items-center">
				<Wrapper>
					<div className="bg-white px-6 py-24 dark:bg-background sm:py-32 lg:px-8">
						<div className="mx-auto max-w-2xl text-left">
							<h2 className="mt-2 text-center text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-6xl">
								Privacy Policy
							</h2>
							<p className="my-6 py-4 text-center text-lg leading-8 text-gray-600 dark:text-gray-300">
								This Privacy Policy describes Our policies and procedures on the
								collection, use, and disclosure of Your information when You use
								the Service and tells You about Your privacy rights and how the
								law protects You.
							</p>
							<h3 className="text-lg font-semibold">
								1. Information Collection and Use
							</h3>
							<p className="py-4 leading-8">
								For a better experience, while using our Service, we may require
								you to provide us with certain personally identifiable
								information. The information that we request will be retained by
								us and used as described in this privacy policy.
							</p>
							<h3 className="text-lg font-semibold">2. Log Data</h3>
							<p className="py-4 leading-8">
								We want to inform you that whenever you use our Service, in a
								case of an error in the app we collect data and information
								(through third party products) on your phone called Log Data.
								This Log Data may include information such as your device
								Internet Protocol (“IP”) address, device name, operating system
								version, the configuration of the app when utilizing our
								Service, the time and date of your use of the Service, and other
								statistics.
							</p>
							<h3 className="text-lg font-semibold">3. Cookies</h3>
							<p className="py-4 leading-8">
								Cookies are files with a small amount of data that are commonly
								used as anonymous unique identifiers. These are sent to your
								browser from the websites that you visit and are stored on your
								device's internal memory.
							</p>
							<h3 className="text-lg font-semibold">4. Service Providers</h3>
							<p className="py-4 leading-8">
								We may employ third-party companies and individuals due to the
								following reasons:
								<ul>
									<li>To facilitate our Service;</li>
									<li>To provide the Service on our behalf;</li>
									<li>To perform Service-related services; or</li>
									<li>To assist us in analyzing how our Service is used.</li>
								</ul>
								These third parties have access to your Personal Information
								only to perform these tasks on our behalf and are obligated not
								to disclose or use it for any other purpose.
							</p>
							<h3 className="text-lg font-semibold">5. Security</h3>
							<p className="py-4 leading-8">
								We value your trust in providing us your Personal Information,
								thus we are striving to use commercially acceptable means of
								protecting it. But remember that no method of transmission over
								the internet, or method of electronic storage is 100% secure and
								reliable, and we cannot guarantee its absolute security.
							</p>
							<p className="mt-6">
								If you have any questions or suggestions about our Privacy
								Policy, do not hesitate to contact us at hello@toptimelines.com.
							</p>
						</div>
					</div>
				</Wrapper>
			</div>
			<Footer />
		</main>
	)
}

export const meta: MetaFunction = () => [{ title: 'Top Timelines | Privacy' }]
